import React, { useState, useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Verticals } from "@/components/site/Verticals";
import { ProductGrid } from "@/components/site/ProductGrid";
import { Manifesto } from "@/components/site/Manifesto";
import { ManufacturerMarquee } from "@/components/site/ManufacturerMarquee";
import { Facade } from "@/components/site/Facade";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { QuoteDialog } from "@/components/site/QuoteDialog";
import AdminPage from "@/components/admin/AdminPage";

function Landing() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const openQuote = () => setQuoteOpen(true);

  return (
    <div className="App" data-testid="app-root">
      <Header onQuote={openQuote} />
      <main>
        <Hero onQuote={openQuote} />
        <Verticals />
        <ProductGrid />
        <Manifesto />
        <ManufacturerMarquee />
        <Facade />
        <FAQ />
        <Contact />
      </main>
      <Footer onQuote={openQuote} />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
